<template>
    <section class="organizador-section">
      <HomeInicio />
      <div class="organizador-container">
        <div class="mesa-tipo-selector">
          <label class="radio-label">
            <input type="radio" value="redonda" v-model="tipoSeleccionado" class="custom-radio" />
            <span class="radio-text">Mesa redonda </span>
          </label>
          <label class="radio-label">
            <input type="radio" value="cuadrada" v-model="tipoSeleccionado" class="custom-radio" />
            <span class="radio-text">Mesa cuadrada </span>
          </label>
        </div>
  
        <div style="margin: 10px 0;">
          <button class="btn-agregar-mesa" @click="agregarMesa">Agregar mesa</button>
        </div>
  
        <div class="layout">
          <div class="lista-invitados" @dragover.prevent @drop="handleListDrop">
            <h3 class="titulo-lista">Invitados sin mesa</h3>
            <div class="paginacion">
              <button @click="paginaActual--" :disabled="paginaActual === 1">Anterior</button>
              <span>Página {{ paginaActual }}</span>
              <button
                @click="paginaActual++"
                :disabled="paginaActual * invitadosPorPagina >= invitadosTexto.length"
              >
                Siguiente
              </button>
            </div>
            <div
  v-for="(invitado) in invitadosPaginados"
  :key="`invitado-${invitado.id_invitado}-${invitado.indice}`"
  class="invitado-texto"
  :class="{
  colocado: estaColocado(invitado),
  verde: invitado.estado === 'confirmado',
  marron: invitado.estado === 'excedente',
  gris: invitado.estado === 'no_asiste',
  amarillo: invitado.estado === 'no_confirmado',
  'no-draggable': estaColocado(invitado) || invitado.estado === 'no_asiste' || invitado.estado === 'excedente'

}"
:title="getTooltip(invitado)"

  :draggable="!estaColocado(invitado) && invitado.estado !== 'no_asiste' && invitado.estado !== 'excedente'"
  @dragstart="iniciarArrastre(invitado, $event)"
  @touchstart="iniciarArrastreTouch(invitado, $event)"

>
  <img src="@/assets/user-icon.png" alt="icono" style="width: 16px; margin-right: 6px;" />
  {{ invitado.nombre_mostrar }}
</div>

          </div>
  
          <div
            class="canvas-wrapper"
            @dragover.prevent
            @drop="handleDrop"
            @click="handleTouchDrop"   
            @touchend="handleTouchDrop"
            style="position: relative; width: 1000px; height: 800px; overflow: hidden; border: 2px dashed #ccc;"
          >
          <div class="botones-distribucion">
  <button
    class="btn-guardar-distribucion"
    @click="guardarDistribucion"
    title="Guarda los cambios realizados en la distribución, pero no se asignan aún las mesas al listado principal."
  >
    💾 Guardar distribución
  </button>

  <button
    class="btn-asignar-mesas"
    @click="guardarYAsignar"
    title="Guarda la distribución actual y asigna las mesas correspondientes al listado principal de invitados."
  >
    📌 Guardar y asignar mesas
  </button>
</div>

            <v-stage :config="stageConfig">
              <v-layer :config="{ clipFunc: clipCanvas }">
                <!-- Mesas -->
                <!-- MESAS: renderizadas separadas y estáticas -->
<template v-for="(mesa) in mesasRenderizadas" :key="'mesa-' + mesa.num_mesa">
  <v-group
    :x="mesa.x"
    :y="mesa.y"
    :config="{ draggable: true, dragBoundFunc: limitarDragGlobal }"
    @dragend="moverMesa(mesa, $event)"
  >
    <component
      :is="mesa.tipo === 'redonda' ? 'v-circle' : 'v-rect'"
      :config="mesa.tipo === 'redonda'
        ? { radius: 50, fill: '#90caf9', stroke: '#1e293b', strokeWidth: 2 }
        : { width: 100, height: 100, fill: '#a5d6a7', stroke: '#1e293b', strokeWidth: 2 }"
    />
    <v-text
  :config="{
    text: `Mesa ${mesa.num_mesa}`,
    x: mesa.tipo === 'redonda' ? -30 : 0,
    y: mesa.tipo === 'redonda' ? -8 : 35,
    width: mesa.tipo === 'redonda' ? 60 : 100,
    height: mesa.tipo === 'redonda' ? undefined : 100,
    align: 'center',
    verticalAlign: 'middle',
    fontSize: 13,
    fontStyle: 'bold',
    fill: '#fff',
    fontFamily: 'Playfair Display'
  }"
/>

  </v-group>
</template>
  
                <!-- Invitados: todos independientes -->
                <template v-for="(invitado, i) in invitadosColocadosDirecto" :key="`colocado-${i}`">
                  <v-group
  :config="{
    x: invitado.x,
    y: invitado.y,
    draggable: true,
    dragBoundFunc: limitarDragGlobal
  }"
  @dragend="actualizarPosicionInvitadoMesa(invitado, $event)"
  @dblclick="quitarInvitado(invitado)"
>
  <!-- 🔴 Fondo con color personalizado por grupo de conflicto -->
  <v-circle
  v-if="invitado.error_mesa"
  :config="{
    radius: 18,
    fill: invitado.error_color || 'rgba(255,0,0,0.3)',
    stroke: invitado.error_color || 'red',
    strokeWidth: 2
  }"
/>


  <!-- 👤 Ícono del invitado -->
  <v-image
    v-if="userImage"
    :config="{
      image: userImage,
      width: 28,
      height: 28,
      offsetX: 14,
      offsetY: 14,
      shadowColor: invitado.error_color || 'black',
      shadowBlur: invitado.error_mesa ? 20 : 4,
      shadowOpacity: invitado.error_mesa ? 0.9 : 0.3
    }"
  />

  <!-- ✏️ Nombre del invitado -->
  <v-text
    :config="{
      text: invitado.nombre_mostrar || 'Sin nombre',
      x: -35,
      y: 18,
      fontSize: invitado.nombre_mostrar.length > 15 ? 9 : 11,
      fill: '#444',
      width: 70,
      align: 'center',
      fontFamily: 'Poppins'
    }"
  />
</v-group>

</template>
              </v-layer>
            </v-stage>
          </div>
        </div>
      </div>
    </section>
  </template>
 <script>
 import axios from 'axios';
 import { Stage, Layer, Circle, Rect, Text, Group, Image as KImage } from 'vue-konva';
 import HomeInicio from '@/components/HomeInicio.vue';
 import baseUrl from '../api';  
 import Swal from 'sweetalert2';

 export default {
   name: 'mesas-visualizar',
   components: {
     HomeInicio,
     'v-stage': Stage,
     'v-layer': Layer,
     'v-circle': Circle,
     'v-rect': Rect,
     'v-text': Text,
     'v-group': Group,
     'v-image': KImage
   },
   data() {
     return {
       tipoSeleccionado: 'redonda',
       paginaActual: 1,
       invitadosPorPagina: 20,
       stageConfig: { width: 1000, height: 800, x: 0 },
       invitados: [],
       userImage: null,
       invitadosColocados: [],
       arrastrandoInvitado: null,
       invitadosColocadosDirecto: [],
       mesasManual: [],
       mesasBackend: []
       

     };
   },
   computed: {
    invitadosPaginados() {
  const inicio = (this.paginaActual - 1) * this.invitadosPorPagina;
  const fin = inicio + this.invitadosPorPagina;
  return this.invitados.slice(inicio, fin);
}
,
mesasRenderizadas() {
  const combinadas = [
    ...this.mesasBackend,
    ...this.mesasManual
  ];

  // ✅ Filtrar por num_mesa única (el primero que aparece)
  const unicas = [];
  const numsVistos = new Set();

  for (const mesa of combinadas) {
    if (!numsVistos.has(mesa.num_mesa)) {
      numsVistos.add(mesa.num_mesa);
      unicas.push({
        id: mesa.id || null,
        num_mesa: mesa.num_mesa,
        x: mesa.x,
        y: mesa.y,
        tipo: mesa.tipo_mesa || mesa.tipo || 'redonda'
      });
    }
  }

  return unicas;
}
,
  invitadosTexto() {
  if (!this.invitados || this.invitados.length === 0) return [];

  const lista = [];
  for (const invitado of this.invitados) {
    const cantidad = parseInt(invitado.pases_asignados) || 1;
    for (let i = 0; i < cantidad; i++) {
      lista.push({
        ...invitado,
        indice: i,
        nombre_mostrar_completo: `${invitado.nombre_mostrar} ${i + 1}`
      });
    }
  }
  return lista;
}

,
     mesaShapeConfig() {
       return this.tipoMesa === 'redonda'
         ? { radius: 50, fill: '#90caf9', stroke: '#1e293b', strokeWidth: 2 }
         : { width: 100, height: 100, fill: '#a5d6a7', stroke: '#1e293b', strokeWidth: 2 };
     }
   },
   methods: {
    handleTouchDrop(e) {
  if (!this.arrastrandoInvitado || !this.userImage) return;

  const boundingBox = e.currentTarget.getBoundingClientRect();
  const rawX = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - boundingBox.left;
  const rawY = (e.changedTouches ? e.changedTouches[0].clientY : e.clientY) - boundingBox.top;
  const { x, y } = this.limitarDragGlobal({ x: rawX, y: rawY });

  const mesaDetectada = this.obtenerMesaCercana(x, y);
  const mesaEncontrada = this.mesasBackend.find(
    m => String(m.num_mesa) === String(mesaDetectada)
  );

  const idUnico = this.arrastrandoInvitado.id_invitado + '-' + this.arrastrandoInvitado.indice;

  const invitadoExistente = this.invitadosColocadosDirecto.find(
    i => `${i.id_invitado}-${i.indice}` === idUnico
  );

  if (!invitadoExistente) {
    this.invitadosColocados.push(idUnico);

    this.invitadosColocadosDirecto.push({
      ...this.arrastrandoInvitado,
      x,
      y,
      num_mesa: mesaDetectada || null,
      id_mesa: mesaEncontrada?.id || null,
      tipo_mesa: mesaEncontrada?.tipo || null,
      nombre_mostrar: this.arrastrandoInvitado.nombre_mostrar_completo || this.arrastrandoInvitado.nombre_mostrar || 'Sin nombre'
    });
  } else {
    invitadoExistente.x = x;
    invitadoExistente.y = y;
    invitadoExistente.num_mesa = mesaDetectada || null;
    invitadoExistente.id_mesa = mesaEncontrada?.id || null;
    invitadoExistente.tipo_mesa = mesaEncontrada?.tipo || null;
  }

  this.arrastrandoInvitado = null;
}
,
    iniciarArrastreTouch(invitado, event) {
  this.arrastrandoInvitado = { ...invitado };
  event.stopPropagation(); // para que no lo trate de scrollear
},
    async guardarYAsignar() {
  // 1️⃣ Guardar distribución primero
  await this.guardarDistribucion();

  // 2️⃣ Luego asignar las mesas
  await this.asignarMesasAInvitados();
}
,
    getErrorColor(id_invitado) {
  const tonos = [
    'rgba(255, 100, 100, 0.4)',
    'rgba(255, 70, 70, 0.4)',
    'rgba(255, 50, 50, 0.4)',
    'rgba(220, 30, 30, 0.4)',
    'rgba(190, 0, 0, 0.4)'
  ];
  return tonos[parseInt(id_invitado) % tonos.length];
}
,
    async asignarMesasAInvitados() {
  const id_festejada = localStorage.getItem('id_festejada');
  const confirmacion = await Swal.fire({
    title: '¿Asignar mesas a los invitados?',
    html: 'Esto actualizará las mesas asignadas en el listado principal de invitados.<br><br>' +
          'Puedes volver a hacerlo si realizas cambios en la distribución.<br><br>' +
          '<strong>¿Deseas continuar?</strong>',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#5f6770',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, asignar mesas',
    cancelButtonText: 'Cancelar'
  });
  if (!confirmacion.isConfirmed) return;
  
  try {
    await axios.post(`${baseUrl}/api2/modificar-mesas-invitados`, {
      id_festejada
    });

    Swal.fire({
      icon: 'success',
      title: '¡Listo!',
      text: 'Las mesas se asignaron correctamente a cada invitado.',
      confirmButtonColor: '#5f6770'
    });
  } catch (error) {
    console.error('❌ Error al asignar mesas:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudieron asignar las mesas.',
      confirmButtonColor: '#d33'
    });
  }
}
,
    quitarInvitado(invitado) {
  const idUnico = `${invitado.id_invitado}-${invitado.indice}`;

  // 🔙 Quitar del lienzo
  this.invitadosColocadosDirecto = this.invitadosColocadosDirecto.filter(
    i => `${i.id_invitado}-${i.indice}` !== idUnico
  );

  // ✅ Habilitar de nuevo en la lista
  this.invitadosColocados = this.invitadosColocados.filter(id => id !== idUnico);
}
,
    getTooltip(invitado) {
  switch (invitado.estado) {
    case 'no_asiste':
      return '❌ No asistirá';
    case 'excedente':
      return '❌ Pase no asistirá';
    case 'confirmado':
      return '✅ Confirmado';
    default:
      return '🕒 No ha confirmado';
  }
}

,
    iniciarArrastreSubinvitado(invitado, subindice, event) {
      this.arrastrandoInvitado = {
        ...invitado,
        indice: subindice - 1,
        nombre_mostrar: `${invitado.nombre_mostrar} ${subindice}`
      };
      if (event?.dataTransfer) {
        event.dataTransfer.setData('text/plain', 'subinvitado');
        event.dataTransfer.effectAllowed = 'move';
      }}
    
,
obtenerMesaCercana(x, y) {
  const umbral = 90;
  let mesaCercana = null;
  let menorDistancia = Infinity;
  for (const mesa of this.mesasRenderizadas) {
    const distancia = Math.sqrt((x - mesa.x) ** 2 + (y - mesa.y) ** 2);
    if (distancia < menorDistancia && distancia <= umbral) {
      menorDistancia = distancia;
      mesaCercana = mesa.num_mesa;
    }
  }
  return mesaCercana;
}
,
limitarDragGlobal(pos) {
  const margen = 74; // suficiente, ya que offsetX es 14
  const w = this.stageConfig.width;
  const h = this.stageConfig.height;

  return {
    x: Math.max(margen, Math.min(w - margen, pos.x)),
    y: Math.max(margen, Math.min(h - margen, pos.y))
  };
}

,
     actualizarPosicionInvitadoMesa(invitado, event) {
       const { x, y } = event.target.position();
       invitado.x = x;
       invitado.y = y;
       const nuevaMesa = this.obtenerMesaCercana(x, y);
       invitado.num_mesa = nuevaMesa || null;
       console.log(`Invitado ${invitado.nombre_mostrar} asignado a mesa ${invitado.num_mesa}`);
     },
     agregarMesa() {
  const usados = [
    ...this.mesasBackend.map(m => m.num_mesa),
    ...this.mesasManual.map(m => m.num_mesa)
  ];
  const siguienteNum = usados.length > 0 ? Math.max(...usados) + 1 : 1;

  // ✅ Checar si ya existe una mesa manual con ese número
  const yaExiste = this.mesasManual.some(m => m.num_mesa === siguienteNum);
  if (yaExiste) return; // ❌ No la agregues de nuevo

  const nuevaMesa = {
    num_mesa: siguienteNum,
    tipo: this.tipoSeleccionado,
    x: 150,
    y: 150
  };

  this.mesasManual.push(nuevaMesa);
}

,
     clipCanvas(ctx) {
       ctx.rect(0, 0, 1000, 800);
     },
     estaColocado(invitado) {
  const idUnico = `${invitado.id_invitado}-${invitado.indice}`;
  return this.invitadosColocados.includes(idUnico);
}
,
async moverMesa(mesa, e) {
  const pos = e.target.position();
  const nuevaX = Math.max(0, Math.min(this.stageConfig.width, pos.x));
  const nuevaY = Math.max(0, Math.min(this.stageConfig.height, pos.y));

  mesa.x = nuevaX;
  mesa.y = nuevaY;

  const id_festejada = localStorage.getItem('id_festejada');

  const indexManual = this.mesasManual.findIndex(m => m.num_mesa === mesa.num_mesa);
  const indexBackend = this.mesasBackend.findIndex(m => m.num_mesa === mesa.num_mesa);

  if (indexManual !== -1) {
    this.mesasManual[indexManual] = {
      ...this.mesasManual[indexManual],
      x: nuevaX,
      y: nuevaY
    };
  } else if (indexBackend !== -1) {
    this.mesasBackend[indexBackend] = {
      ...this.mesasBackend[indexBackend],
      x: nuevaX,
      y: nuevaY
    };

    // 🔄 Guardar posición actualizada en el backend
    try {
      await axios.put(`${baseUrl}/api2/actualizar-mesa`, {
        id_festejada,
        num_mesa: mesa.num_mesa,
        x: nuevaX,
        y: nuevaY
      });
      console.log(`✅ Mesa ${mesa.num_mesa} actualizada en backend`);
    } catch (error) {
      console.error('❌ Error al actualizar mesa en backend:', error);
    }
  }
}

,
iniciarArrastre(invitado, event) {
  this.arrastrandoInvitado = { ...invitado };

  const preview = document.getElementById('drag-preview');
  if (event.dataTransfer && preview) {
    event.dataTransfer.setDragImage(preview, 14, 14); // Ajuste centrado
    event.dataTransfer.setData('text/plain', 'subinvitado');
    event.dataTransfer.effectAllowed = 'move';
  }
}


,
     handleListDrop() {
       const indexToRemove = this.invitadosColocadosDirecto.findIndex(
         invitado => invitado.id_invitado === this.arrastrandoInvitado.id_invitado &&
                     invitado.indice === this.arrastrandoInvitado.indice
       );
       if (indexToRemove !== -1) {
         const idUnico = this.arrastrandoInvitado.id_invitado + '-' + this.arrastrandoInvitado.indice;
         this.invitadosColocados = this.invitadosColocados.filter(id => id !== idUnico);
         this.invitadosColocadosDirecto.splice(indexToRemove, 1);
       }
       this.arrastrandoInvitado = null;
     },
     handleDrop(e) {
  if (!this.arrastrandoInvitado || !this.userImage) return;

  const boundingBox = e.currentTarget.getBoundingClientRect();
  const rawX = e.clientX - boundingBox.left;
  const rawY = e.clientY - boundingBox.top;
  const { x, y } = this.limitarDragGlobal({ x: rawX, y: rawY });

  const mesaDetectada = this.obtenerMesaCercana(x, y);
  const mesaEncontrada = this.mesasBackend.find(
    m => String(m.num_mesa) === String(mesaDetectada)
  );

  const idUnico = this.arrastrandoInvitado.id_invitado + '-' + this.arrastrandoInvitado.indice;

  const invitadoExistente = this.invitadosColocadosDirecto.find(
    i => `${i.id_invitado}-${i.indice}` === idUnico
  );

  if (!invitadoExistente) {
    // Si no existe todavía, lo agregamos
    this.invitadosColocados.push(idUnico);

    this.invitadosColocadosDirecto.push({
      ...this.arrastrandoInvitado,
      x,
      y,
      num_mesa: mesaDetectada || null,
      id_mesa: mesaEncontrada?.id || null,
      tipo_mesa: mesaEncontrada?.tipo || null,
      nombre_mostrar: this.arrastrandoInvitado.nombre_mostrar_completo || this.arrastrandoInvitado.nombre_mostrar || 'Sin nombre'
    });
  } else {
    // Si ya existe, solo actualizamos su posición
    invitadoExistente.x = x;
    invitadoExistente.y = y;
    invitadoExistente.num_mesa = mesaDetectada || null;
    invitadoExistente.id_mesa = mesaEncontrada?.id || null;
    invitadoExistente.tipo_mesa = mesaEncontrada?.tipo || null;
  }

  this.arrastrandoInvitado = null;

},async guardarDistribucion() {
  const id_festejada = localStorage.getItem('id_festejada');
  const erroresSubinvitados = new Set();

  try {
    // 1️⃣ Guardar mesas manuales
    for (const mesa of this.mesasManual) {
      if (!mesa.num_mesa || mesa.num_mesa === null) continue;
      await axios.post(`${baseUrl}/api2/guardar-mesas`, {
        id_festejada,
        num_mesa: mesa.num_mesa,
        x: mesa.x,
        y: mesa.y,
        tipo_mesa: mesa.tipo
      });
    }

    // 2️⃣ Recargar mesas
    const mesasResponse = await axios.get(`${baseUrl}/api2/mesas?id_festejada=${id_festejada}`);
    this.mesasBackend = mesasResponse.data;

    // 3️⃣ Agrupar subinvitados por id_invitado
    const agrupados = {};
    for (const inv of this.invitadosColocadosDirecto) {
      const clave = `${inv.id_invitado}`;
      if (!agrupados[clave]) agrupados[clave] = [];
      agrupados[clave].push(inv);
    }

    // 4️⃣ Validar si todos los subinvitados están en la misma mesa
    for (const [id, grupo] of Object.entries(agrupados)) {
      const mesasDelGrupo = new Set(grupo.map(i => i.num_mesa));
      if (mesasDelGrupo.size > 1) {
        erroresSubinvitados.add(Number(id));
      }
    }

    // 5️⃣ Guardar posiciones válidas
    for (const invitado of this.invitadosColocadosDirecto) {
      if (erroresSubinvitados.has(invitado.id_invitado)) continue;

      const payload = {
        id_festejada,
        id_invitado: invitado.id_invitado,
        subindice: invitado.indice,
        x: invitado.x,
        y: invitado.y,
        num_mesa: invitado.num_mesa || null,
        tipo_mesa: invitado.tipo_mesa || null
      };
      console.log('Enviando datos al backend:', {
  id_festejada,
  id_invitado: invitado.id_invitado,
  subindice: invitado.subindice,
  x: invitado.x,
  y: invitado.y,
  num_mesa: invitado.num_mesa,
  tipo_mesa: invitado.tipo_mesa
});

      await axios.put(`${baseUrl}/guardar-posicion`, payload);
    }

    // 6️⃣ Marcar errores visualmente
    const tonos = ['#f44336', '#2196f3', '#4caf50', '#ff9800', '#9c27b0', '#009688', '#e91e63', '#3f51b5', '#795548', '#607d8b'];
    const colorPorInvitado = {};
    let grupoIndex = 0;

    erroresSubinvitados.forEach(id => {
      colorPorInvitado[id] = tonos[grupoIndex % tonos.length];
      grupoIndex++;
    });

    this.invitadosColocadosDirecto = this.invitadosColocadosDirecto.map(inv => {
      const tieneError = erroresSubinvitados.has(inv.id_invitado);
      return {
        ...inv,
        error_mesa: tieneError,
        error_color: tieneError ? colorPorInvitado[inv.id_invitado] : null
      };
    });

    // 7️⃣ Mostrar mensaje final
    if (erroresSubinvitados.size > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        html: `Algunos subinvitados están en mesas diferentes.<br><strong>Corrige los resaltados en colores.</strong>`,
        confirmButtonColor: '#d33'
      });
    } else {
      Swal.fire({
        icon: 'success',
        title: '¡Distribución guardada!',
        text: 'Se han guardado correctamente las posiciones y mesas.',
        confirmButtonColor: '#5f6770'
      });
    }

  } catch (error) {
    console.error('❌ Error inesperado al guardar distribución:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error inesperado',
      text: 'Hubo un problema al guardar la distribución.',
      confirmButtonColor: '#d33'
    });
  }
}

,
     loadUserIcon() {
       const img = new Image();
       img.src = require('@/assets/user-icon.png');
       img.onload = () => {
         this.userImage = img;
       };
     },
     getIconoX(index, total) {
       const angle = (2 * Math.PI / total) * index;
       return Math.cos(angle) * 65;
     },
     getIconoY(index, total) {
       const angle = (2 * Math.PI / total) * index;
       return Math.sin(angle) * 65;
     },
     async cargarInvitados() {
  try {
    const id_festejada = localStorage.getItem('id_festejada');

    const [posiciones, invitados, mesas] = await Promise.all([
      axios.get(`${baseUrl}/api2/visualizar-mesa?id_festejada=${id_festejada}`),
      axios.get(`${baseUrl}/api2/invitados-mesa?id_festejada=${id_festejada}`),
      axios.get(`${baseUrl}/api2/mesas?id_festejada=${id_festejada}`) // ⬅️ Este es el que carga las mesas
    ]);

    this.invitadosColocadosDirecto = posiciones.data.map(item => ({
      id_invitado: item.id_invitado,
      indice: item.subindice,
      x: item.x,
      y: item.y,
      num_mesa: item.num_mesa,
      tipo_mesa: item.tipo_mesa,
      nombre_mostrar: `${item.nombre_mostrar || 'Sin nombre'} ${item.subindice + 1}`
    }));

    this.invitados = [];

invitados.data.forEach(inv => {
  const totalPases = parseInt(inv.pases_asignados) || 1;
  const confirmados = parseInt(inv.pases_confirmados) || 0;

  for (let i = 0; i < totalPases; i++) {
    const estado =
      inv.asistira === 'no' ? 'no_asiste'
      : inv.asistira === 'si' && i >= confirmados ? 'excedente'
      : inv.asistira === 'si' ? 'confirmado'
      : 'no_confirmado';

    this.invitados.push({
      ...inv,
      indice: i,
      estado,
      nombre_mostrar: `${inv.nombre_mostrar.slice(0, 18)} ${i + 1}`
    });
  }
});



    this.mesasBackend = mesas.data;

    this.invitadosColocados = this.invitadosColocadosDirecto.map(
      i => `${i.id_invitado}-${i.indice}`
    );
  } catch (error) {
    console.error('Error al cargar datos:', error);
  }
}

     
   },
   mounted() {
    if (!localStorage.getItem('nuevaFuncionalidadMostrada')) {
  Swal.fire({
    icon: 'info',
    title: '¡Nueva funcionalidad!',
    html: 'Esta sección para asignar mesas está en fase de pruebas.<br><br>' +
          'Si detectas algún detalle, por favor repórtalo. 🙌<br><br>' +
          '<strong>Importante:</strong> Al momento de armar las mesas, asegúrate de colocar los invitados <u>muy cerca de la mesa</u> para que sean asignados correctamente. 🎯',
    confirmButtonColor: '#5f6770'
  });

  // Marcamos que ya se mostró
  localStorage.setItem('nuevaFuncionalidadMostrada', 'true');
}


     this.cargarInvitados();
     this.loadUserIcon();
   }
 };
  </script>
  <style scoped>
.canvas-wrapper {
  min-width: 800px; /* para que sí active scroll si es necesario */
  width: 100%;
  max-width: 1000px;
  height: 800px;
  background-color: #f8f8f8;
  border: 2px solid #ccc;
  overflow: hidden;
  flex-shrink: 0; /* 👈 importante */
}
  .organizador-section {
    padding-top: 120px;
    background-color: #fff;
    min-height: 100vh;
  }
  .organizador-container {
    padding: 20px 30px;
    max-width: 1300px;
    margin: 0 auto;
  }
  .mesa-tipo-selector {
    margin-bottom: 30px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    color: #1e1e1e;
    display: flex;
    gap: 40px;
    justify-content: center;
    align-items: center;
  }
  .layout {
  display: flex;
  gap: 20px;
  flex-wrap: nowrap; /* importante */
  overflow-x: hidden; /* 👈 oculta la barra en escritorio */
}
.lista-invitados {
  width: 250px;
  font-family: 'Poppins', sans-serif;
  padding: 10px;
  background: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 8px;
  height: auto; /* 🔄 se adapta al contenido */
  max-height: none; /* 🔄 sin límite fijo */
  overflow-y: auto;
  flex-shrink: 0;
}

  .titulo-lista {
    font-family: 'Playfair Display', serif;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;
    text-align: center;
  }
  .invitado-texto {
    background: #fff5e0;
    border: 1px solid #fbbf24;
    border-radius: 6px;
    padding: 6px 10px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: move;
    overflow-wrap: break-word;
  }
  .radio-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }
  .custom-radio {
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #8c7e6e;
    border-radius: 50%;
    position: relative;
    outline: none;
    cursor: pointer;
  }
  .custom-radio:checked::before {
    content: '';
    width: 10px;
    height: 10px;
    background-color: #8c7e6e;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }
  .radio-text {
    font-family: 'Playfair Display', serif;
    font-size: 18px;
    font-weight: 700;
    color: #1e1e1e;
  }

  .paginacion {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
}
.paginacion {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 15px;
  font-family: 'Poppins', sans-serif;
}

.paginacion button {
  background-color: #fbbf24;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  color: white;
  transition: background 0.3s;
}

.paginacion button:hover:not(:disabled) {
  background-color: #f59e0b;
}

.paginacion button:disabled {
  background-color: #ddd;
  cursor: not-allowed;
}

.paginacion span {
  font-weight: bold;
  font-size: 15px;
}
.deshabilitado {
  opacity: 0.4;
  pointer-events: none;
}


.btn-agregar-mesa {
  background-color: #5f6770;
  color: white;
  border: none;
  padding: 8px 16px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.btn-agregar-mesa:hover {
  background-color: #3f4850;
}
.btn-guardar-distribucion {
  background-color: #4caf50;
  color: white;
  padding: 8px 16px;
  font-family: 'Poppins', sans-serif;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.btn-guardar-distribucion:hover {
  background-color: #388e3c;
}
.invitado-texto[title]:hover {
  background-color: #f5f5f5;
  cursor: help;
}

.btn-asignar-mesas {
  background-color: #e7dbd2;
  color: rgb(56, 52, 52);
  padding: 8px 16px;
  font-family: 'Poppins', sans-serif;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.btn-asignar-mesas:hover {
  background-color: #e2d3cd;
}

.botones-distribucion {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  align-items: center;
}


.colocado {
  opacity: 0.4;
  pointer-events: none;
  text-decoration: line-through;
}

.no-draggable {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: auto; /* 🔥 IMPORTANTE: para que el tooltip siga funcionando */
}
.verde {
  background-color: #e8f5e9;
  color: #2e7d32;
  border-left: 4px solid #4caf50;
}

.gris {
  background-color: #f5f5f5;
  color: #616161;
  border-left: 4px solid #9e9e9e;
}

.marron {
  background-color: #efebe9;
  color: #5d4037;
  border-left: 4px solid #8d6e63;
}

.amarillo {
  background-color: #fcfbf9;
  color: #3f3d38;
  border-left: 4px solid #ebe9e4;
}

.no-draggable {
  cursor: not-allowed;
  opacity: 0.6;
}


/* ✅ Para pantallas pequeñas */
  @media (max-width: 768px) {
  .lista-invitados {
    width: 180px;
    max-height: calc(100vh - 240px); /* 🔥 usa casi toda la pantalla disponible */
    font-size: 12px;
    overflow-y: auto;
  }
  .mesa-tipo-selector {
  flex-direction: column;
  align-items: flex-end; /* 🔥 alinea a la derecha */
  justify-content: center;
  gap: 16px;
  text-align: right;
}
  .layout {
    overflow-x: auto;
  }
  .canvas-wrapper {
    min-width: 600px; /* lienzo más pequeño en móvil */
    height: 600px;
  }

  .paginacion {
    flex-wrap: wrap;
    gap: 6px;
  }
}
  </style>
  